export default __webpack_public_path__ + "static/media/estrutura4.52ebc462.jpg";